const costEndpoint = `${process.env.VUE_APP_URL}/api/v1/cost/`;
// cost pools are using mixins
export default {
  namespaced: true,
  state: {
    userCompanies:[],
    companyDetails: {},
    companyRequests: [],
    companyInvitations:[],
  },
  mutations: {
    SET_USER_COMPANIES(state, data){
      state.userCompanies=data
    },
    SET_COMPANY_DETAILS(state, data){
      state.companyDetails = data
    },
  },
  getters:{
  },
  actions: {
    getCompanyRequests({state}, {context}){
      context.$http.get(`${process.env.VUE_APP_URL}/api/v1/account/company-requests/`)
        .then(response => {
            state.companyRequests = response.data;
        })
    },
    getCompanyInvitations({state},{context, companyId}){
      if(companyId){
        context.$http.get(`${process.env.VUE_APP_URL}/api/v1/account/company-invitations/?company=${companyId}`)
        .then(response => {
          state.companyInvitations = response.data
        })
      }
      
    }
  },
}
